import { useState, useEffect } from 'react';
import Link from '@mui/material/Link';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import { Quote } from '../../../../../../Typescript/backend/classes';
import { useNextQuoteEdition } from '../../../../../../hooks';

// ----------------------------------------------------------------------
interface QuoteHasNextEditionWarningProps {
  quote: Quote | null;
}

export function QuoteHasNextEditionWarning({
  quote,
}: QuoteHasNextEditionWarningProps) {
  const relationship = useNextQuoteEdition(quote?.uniqueId);
  const [isRenewal, setIsRenewal] = useState<boolean>(false);
  const [nextEditionUUID, setNextEditionUUID] = useState<string | null>(null);

  useEffect(() => {
    if (relationship) {
      setIsRenewal(relationship.reason === 'RENEWAL');
      setNextEditionUUID(relationship.nextEdition?.uniqueID || null);
    } else {
      setIsRenewal(false);
      setNextEditionUUID(null);
    }
  }, [relationship]);

  if (!quote) {
    return null;
  }

  return (
    <Collapse in={!!relationship && !!nextEditionUUID}>
      <Alert severity='error'>
        {isRenewal
          ? 'This quote has been renewed. View the '
          : 'This quote has a next edition. View the '}
        <Link href={`/insurtech/manager/quotes/details/${nextEditionUUID}`}>
          {isRenewal ? 'renewed edition' : 'next edition'}
        </Link>
        .
      </Alert>
    </Collapse>
  );
}
